import Category from './Category.view';

export default Category;
